import React from "react";

import { TextFieldProps } from "@mui/material";
import { AsyncAutocomplete } from "components/forms";
import { useActionHook } from "hooks";
import { useDealActions } from "store";

export interface CharAutocompleteProps {
  onChange: (value: string) => void;
  className?: TextFieldProps["className"];
  sx?: TextFieldProps["sx"];
  characteristicId: number;
  charName: string;
  defaultValue?: string;
  value?: string;
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
}

export const CharAutocomplete: React.FC<CharAutocompleteProps> = ({
  onChange,
  characteristicId,
  charName,
  value,
  defaultValue,
  placeholder,
  ...props
}) => {
  const { getCharValuesAction } = useDealActions();

  const { data, loading, action, resetData } = useActionHook(getCharValuesAction);

  return (
    <AsyncAutocomplete
      label={charName}
      placeholder={placeholder}
      value={value}
      defaultValue={defaultValue}
      onChange={(value: string) => {
        onChange(value);
        if (data?.length) {
          resetData();
        }
      }}
      fetchData={(s: string) => action(s, characteristicId)}
      options={data}
      loading={loading}
      {...props}
    />
  );
};
